import { createContext, useContext } from 'react';
export const PostOfficeContext = createContext({
    product: undefined,
    locale: undefined,
});
export const PostOfficeContextProvider = PostOfficeContext.Provider;
export const usePostOfficeContext = () => useContext(PostOfficeContext);
//# sourceMappingURL=usePostOfficeContext.js.map